import moment from 'moment';
import { TipoServicioLabel } from '../models';



export const formatDateTime = (dateTime: any) => {
  if (!dateTime) return 'N/A';
  return moment(dateTime).format('DD/MM/YYYY HH:mm');
};

export const formatAddress = (address: any) => {
  if (!address) return 'N/A';
  return (
    address.text ||
    `${address.calle || ''} ${address.numero || ''}, ${
      address.localidad || ''
    }, ${address.provincia || ''}`.trim()
  );
};

export const formatPassenger = (passenger: any) => {
  if (!passenger) return 'N/A';
  return `${passenger.name || 'Sin nombre'}${
    passenger.phone ? ` - 📞 ${passenger.phone}` : ''
  }`;
};

const generateText = (reservations: any) => {
  const reservationTexts = reservations.map((reservation: any) => {
    let text = `\n🚗  RESERVA #${reservation.id}\n`;

    // Información básica

    text += `\n📅  Fecha de reserva: ${formatDateTime(
      reservation.reservationDatetime
    )}\n`;

    text += `\n🛣  RECORRIDO:\n`;

    reservation.locations?.forEach((location, index) => {
      text += `\n Punto ${index + 1}:\n`;
      text += `📍 ${formatAddress(location.address)}\n`;

      if (location.observation) {
        text += `📝 Obs: ${location.observation}\n`;
      }

      if (location.passengers && location.passengers.length > 0) {
        text += `👥  Pasajeros:\n`;
        location.passengers.forEach((passenger, pIndex) => {
          text += `   ${pIndex + 1}. ${formatPassenger(passenger)}\n`;
        });
      }
    });

    text += `\n🚙  Tipo de Servicio: ${TipoServicioLabel[`${reservation.serviceType}`] || 'N/A'}\n`;

    // Agregar link de seguimiento al final
    if (reservation.encrypted_id) {
      text += `\n🔗  Seguimiento: https://tracking.lltraslados.com.ar/travel/${reservation.encrypted_id}`;
    }

    return text;
  });

  // Unir todas las reservas con separadores
  return reservationTexts.join('\n---------------------------\n');
};

// Función para calcular el número de caracteres aproximado de una reserva
const calculateReservationLength = (reservation: any) => {
  const text = generateText([reservation]);
  return text.length;
};

// Función para agrupar reservas en lotes optimizados para WhatsApp
export const groupReservationsForWhatsApp = (reservations: any[]) => {
  const MAX_CHARS_PER_MESSAGE = 4000; // Límite conservador para WhatsApp
  const groups: any[][] = [];
  let currentGroup: any[] = [];
  let currentGroupLength = 0;

  for (const reservation of reservations) {
    const reservationLength = calculateReservationLength(reservation);

    // Si agregar esta reserva excede el límite, crear un nuevo grupo
    if (
      currentGroupLength + reservationLength > MAX_CHARS_PER_MESSAGE &&
      currentGroup.length > 0
    ) {
      groups.push([...currentGroup]);
      currentGroup = [reservation];
      currentGroupLength = reservationLength;
    } else {
      currentGroup.push(reservation);
      currentGroupLength += reservationLength;
    }
  }

  // Agregar el último grupo si tiene elementos
  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
};

export const copyToClipboard = async (reservations: any) => {
  try {
    const text = generateText(reservations);
    await navigator.clipboard.writeText(text);
    // Aquí podrías agregar una notificación de éxito
    console.log('Texto copiado al portapapeles');
  } catch (err) {
    console.error('Error al copiar al portapapeles:', err);
  }
};

// Nueva función para copiar un grupo específico
export const copyGroupToClipboard = async (
  reservations: any[],
  groupIndex: number,
  totalGroups: number
) => {
  try {
    let text = generateText(reservations);

    if (totalGroups > 1) {
      text = `          (Mensaje ${groupIndex + 1} de ${totalGroups})\n${text}`;
    }

    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error('Error al copiar al portapapeles:', err);
  }
};



export const generateToDriverText = (r: any) => {
  // 1. Extraer Origen y Destino

  // 4. Construir el mensaje final
  let text = `Cliente: ${r.client?.name || 'N/A'}\n\n`;
  
  text += `📅 Fecha/Hora: ${formatDateTime(r.reservationDatetime)}\n\n`;

  r.locations?.forEach((location, index) => {
    text += `${index + 1}📍: ${formatAddress(location.address)}`;
    text += ` ${location.passengers?.length > 0 ? `\n\n\u2002\u2002👥 Pasajeros (${location.passengers?.length || 0}):\n` : ''}`;
    text += `${location.passengers?.map((p, i) => `\u2002\u2002\u2002\u2002\u2002${i + 1}. ${formatPassenger(p)}`).join('\n') || ''}\n\n`;
  });
  
  text += `${r.general_observation ? `📝 Obs.: ${r.general_observation}` : ''}`;

  return text;
};

export const copyDriverMessageToClipboard = async (reservation: any) => {
  try {
    const text = generateToDriverText(reservation);
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error('Error al copiar datos del chofer:', err);
    throw err;
  }
};